'use client'; // Error components must be Client Components

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="my-20 flex w-full flex-col items-center justify-center">
      <h2>{"Une erreur s'est produite."} </h2>
      <div className="relative mr-5 mt-10 flex items-center justify-center">
        <div className="absolute h-[20px] w-[20px] animate-bounceSlide rounded-full bg-orange-500 shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
            <g strokeWidth="4.142">
              <circle cx="199.3" cy="199.5" r="199.3" fill="#FF7500" />
              <path
                d="M57.7 233.4C57.7 31.5 171 1.5 173.4 1.5v.008L187.44.021c0 .0456-19.62 6.209-29.94 12.42-10.31 6.209-24.1 16.55-37.92 33.05-27.62 33-54.89 90.52-54.91 189.5 0 73.03 36.96 120.3 55.68 139.2 6.234 6.308 23.07 16.43 23.09 16.46l-20.9-7.377c-.2071-.174-64.85-43.3-64.85-150z"
                stroke="black"
              />
              <path
                d="M61.1 189.3c-37.28-4.225-42.72-32.95-42.62-54.65l.174-9.928c.087-9.033.41-10.39.41-10.39l5.505-10.74s-1.773 10.94-1.773 21.14c.1118 21.46 4.958 50.69 38.88 54.39 3.84.4183 7.509.6213 11.04.6213 24.94-2.158 57.79-19.93 98.46-51.17 40.32-30.82 107.5-70.76 158.3-71.27 4.403 0 8.772 1.073 12.06 2.415l5.629 6.084c-2.572-1.06-10.88-1.595-14.93-1.595-35.16-.1532-115.4 42.61-154.8 73-40.38 30.95-67.2 52.72-104.8 52.76-3.69 0-7.513-.2237-11.49-.6586zM221 360.5c-23.43-6.407-52.2-23.68-80.38-37.21-27.24-13.1-54.95-22.97-77.01-26.21-3.09-.3769-5.861-.5302-8.362-.5302-15.37.0704-21.36 6.42-22.81 8.934-.4722.8615-.994 1.495-.994 1.495l-2.655-4.013c.4887-.8739 4.341-15.4 26.35-15.25 2.672 0 5.612.1698 8.855.5592 26.64 3.164 52.69 14.64 79.99 27.76 28.33 13.64 55.95 30.69 78.5 36.83 22.85 6.221 28.81 9.431 45.56 9.448 31.84.0663 55.22-6.706 55.27-6.731l-3.819 2.783c-.0911.008-26.73 9.837-51.71 9.319-17.08.0124-24.08-.9775-46.79-7.182zM61.2 247.6c-11.81-1.731-30.41-6.345-45.13-11.9-14.78-5.542-14.16-8.412-14.16-8.412s-1.164-5.177-1.553-15.01c0 0 4.531 4.208 7.571 5.956 2.005 1.653 6.888 3.906 13.14 6.279l-.6047-.4225c13.56 5.148 31.96 9.713 42.52 11.22 18.85 2.742 49.81 4.842 89.76 4.842 4.283 0 8.677-.029 13.18-.0704 46.14-.4887 117.7-6.399 161.9-17.09 38.73-9.344 60.25-21.86 64.46-24.33.5467-.3521 6.387-3.193 6.387-3.193 2.071-.9071 1.574 11.93-.4308 13.29-.6006.4266-21.67 15.26-67.49 26.32-45.93 11.06-117.6 16.88-164.7 17.43-4.539.0373-8.967.0621-13.3.0704-40.42-.0124-71.75-2.104-91.55-4.97z"
                stroke="black"
              />
            </g>
          </svg>
        </div>
        <span className="relative top-[12px] h-[1px] w-[20px] animate-shadow rounded-full bg-black blur-[1px]"></span>
      </div>
      {/* <button onClick={() => reset()}>Ressayer</button> */}
    </div>
  );
}
